import React from 'react';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { CCardStatsValues } from '@/app/components/Card/Stats/CCardStatsValues';
import IInvestKpis from '@/apps/investor/interfaces/IInvestKpis';
import { TInvestFundCurrency } from '@/apps/investor/types/fund/TInvestFundCurrency';
import investmentKpiLang from '@/apps/investor/langs/investmentKpiLang';
import investmentTypeLang from '@/apps/investor/features/fund-type/langs/investmentTypeLang';

type CapitalKpiProps = {
	kpis: IInvestKpis;
	currency: TInvestFundCurrency;
};
const CCapitalKpi = (props: CapitalKpiProps) => {
	const { kpis, currency } = props;
	const { t } = useTranslation();

	const [committed, setCommited] = useState<number>();
	const [called, setCalled] = useState<number>();
	const [callable, setCallable] = useState<number>();
	const [netCalled, setNetCalled] = useState<number>();

	useEffect(() => {
		if (kpis) {
			setCommited(kpis.committedCapital ?? undefined);
			setCalled(kpis.calledCapital ?? undefined);
			setCallable(kpis.callableCapital ?? undefined);
			setNetCalled(kpis.netCalledCapital ?? undefined);
		}

		return () => {
			setCommited(undefined);
			setCalled(undefined);
			setCallable(undefined);
			setNetCalled(undefined);
		};
	}, [kpis]);

	return (
		<CCardStatsValues
			title={t(investmentTypeLang.capital_kpi.tag)}
			rows={[
				{
					label: t(investmentKpiLang.committed_capital.tag),
					value: committed ?? 0,
					currency: currency,
				},
				{
					label: t(investmentKpiLang.called_capital.tag),
					value: called ?? 0,
					currency: currency,
				},
				{
					label: t(investmentKpiLang.callable_capital.tag),
					tooltip: t(investmentKpiLang.callable_capital_tooltip.tag),
					value: callable ?? 0,
					currency: currency,
				},
				{
					label: t(investmentKpiLang.net_called_capital.tag),
					tooltip: t(investmentKpiLang.net_called_capital_tooltip.tag),
					value: netCalled ?? 0,
					currency: currency,
				},
			]}
		/>
	);
};

export default CCapitalKpi;
